import SwiperBottomOverlayComponent from "./SwiperBottomOverlayComponent";

export default SwiperBottomOverlayComponent;
